module.exports = __webpack_public_path__ + "static/media/coupon.9a738ca7.svg";